<template>
  <div>
    <LoadingSpinner :loading="loading" :text="loadingText" />
    <RegisterTermForm
      v-show="!loading"
      mode="edit"
      :parentPermissions="parentPermissions"
      :resetForm="resetForm"
      :item="item"
      @updateTermDate="updateTermDate"
      @submit="save"
      @close="back"
    />
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import RegisterTermForm from "../forms/registerTermForm.vue";
import { pathOr } from "ramda";

export default {
  components: {
    LoadingSpinner,
    RegisterTermForm,
  },
  data() {
    return {
      code: this.$route.params.code,
      loading: false,
      parentPermissions: [],
      resetForm: false,
      item: null,
      loadingText: this.$lang.receiving_data,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    back() {
      return this.$router.push({ name: "term" });
    },
    updateTermDate(data) {
      this.$emit("updateTermDate", data);
    },
    async save(getPayload) {
      const { company_code, ...payload } = getPayload;
      try {
        this.loading = true;
        this.loadingText = this.$lang.sending_data;
        const url = `${this.$config.api_url}${this.$config.profile.term}/${this.code}`;
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchData() {
      try {
        this.loading = true;
        const url = `${this.$config.api_url}${this.$config.profile.term}/${this.code}`;
        const response = await this.$httpService.get(url);
        this.item = pathOr(null, ["data", "data"], response);
        this.$emit("updateItem", this.item);
        this.parentPermissions = pathOr({}, ["data", "permissions"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
